<script>
  let x = 'wtf svelte?'; // eslint-disable-line
</script>

<div><slot /></div>
